const getDigitStructure = (className: string, style: { transform: string }) => (
    <div className={className} style={style} suppressHydrationWarning>
        {[9, 8, 7, 6, 5, 4, 3, 2, 1, 0].map((digit) => (
            <div key={digit}>{digit}</div>
        ))}
    </div>
);

const getValueStructure = (modifier: string, value: number, offset: number) => (
    <div className={modifier}>
        {getDigitStructure('first-digit', { transform: `translateY(-${(9 - Math.floor(value / 10)) * offset}px)` })}
        {getDigitStructure('second-digit', { transform: `translateY(-${(9 - (value % 10)) * offset}px)` })}
    </div>
);

export const getTile = (url: string, offset: number, value: number, modifier: string) => (
    <div className={'timer__tile'}>
        <img src={url} loading="lazy" alt="background" className="timer__background" style={{ width: '100%' }} />
        <div className={'timer__time'}>{getValueStructure(modifier, value, offset)}</div>
        <div className={'timer__modifier'}>{modifier}</div>
    </div>
);
